import LeftArrows from "../../assets/svg/LeftArrows.svg";
import RightArrows from "../../assets/svg/RightArrows.svg";
import Rectangle from "../../assets/png/Rectangle.png";
import TU01 from "../../assets/png/TU01.png";
import TUSC01 from "../../assets/png/TUSC01.png";
import GASOLINEIMG from "../../assets/png/1000_EFI _GASOLINE.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouterPaths } from "../../router/router";

const ModelSlider = () => {
  const navigate = useNavigate();
  const [activeModels, setActiveModels] = useState("GASOLINE");
  const [animationClass, setAnimationClass] = useState("slide-active");
  const [activeMachine, setActiveMachine] = useState([
    {
      img: GASOLINEIMG,
      title: "TU-1000EFI-2",
      subTitle: "3 seat gas utility vehicle featuring a powerful 1000cc combustion engine and built-in heater.",
      btnName: "EXPLORE 1000EFI",
      link: RouterPaths.EFI,
    },
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const ModelInfo = [
    {
      title: "GASOLINE",
      MachineList: [
        {
          img: GASOLINEIMG,
          title: "TU-1000EFI-2",
          subTitle: "3 seat gas utility vehicle featuring a powerful 1000cc combustion engine and built-in heater.",
          btnName: "EXPLORE 1000EFI",
          link: RouterPaths.EFI,
        },
      ],
    },
    {
      title: "ELECTRIC",
      MachineList: [
        {
          img: Rectangle,
          title: "TU-1500E-2",
          subTitle:
            "3 seat electric utility vehicle equipped with a powerful 15KW motor, a robust 12KWh battery, and a Type 2 charger with 108V 3KW onboard charging system.",
          btnName: "EXPLORE 1500E-2",
          link: RouterPaths.TU1500E2,
        },
        {
          img: Rectangle,
          title: "TU-1500E-3",
          subTitle:
            "3 seat electric utility vehicle with a 21kWh battery, a 15kW motor, an upgraded motor controller, Type 2 charger, 144V 3kW onboard charger (OBC), and a DC-DC converter.",
          btnName: "EXPLORE 1500E-3",
          link: RouterPaths.TU1500E3,
        },
        {
          img: Rectangle,
          title: "TU-1500E-4",
          subTitle:
            "3 seat electric utility vehicle with air conditioning, a 21kWh battery, a 15kW motor, an upgraded motor controller, a Type 2 charger, and a 144V 3kW on-board charger.",
          btnName: "EXPLORE 1500E-4",
          link: RouterPaths.TU1500E4,
        },
      ],
    },
    {
      title: "DUAL MOTOR",
      MachineList: [
        {
          img: TU01,
          title: "TU-DC2500E-01",
          subTitle:
            "6 seat dual cab, dual motor utility vehicle featuring a 6.6KW on-board charger, a 1KW DC-DC converter, a 32A Type 2 charger, digital gauge.",
          btnName: "EXPLORE 2500E",
          link: RouterPaths.TUDC2500E1,
        },
        {
          img: TUSC01,
          title: "TU-SC2500E-01",
          subTitle:
            "3 seat, dual motor utility vehicle featuring a 6.6KW on-board charger, a 1KW DC-DC converter, a 32A Type 2 charger and digital gauge.",
          btnName: "EXPLORE 2500E",
          link: RouterPaths.TUSC2500E1,
        },
      ],
    },
  ];

  const handlePrev = () => {
    if (currentIndex > 0) {
      setAnimationClass("slide-left");
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? activeMachine.length - 1 : prevIndex - 1));
        setAnimationClass("slide-active");
      }, 500); // Match the duration in CSS
    }
  };

  const handleNext = () => {
    if (currentIndex + 1 < activeMachine?.length) {
      setAnimationClass("slide-right");
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex === activeMachine.length - 1 ? 0 : prevIndex + 1));
        setAnimationClass("slide-active");
      }, 500); // Match the duration in CSS
    }
  };

  const handleChangeModelInfo = (item) => {
    setCurrentIndex(0);
    setActiveModels(item.title);
    setActiveMachine(item.MachineList);
  };
  return (
    <>
      <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">
        {ModelInfo.map((item, index) => (
          <div className="flex justify-center mb-[5px]">
            <div
              key={index}
              onClick={() => handleChangeModelInfo(item)}
              className={`${
                activeModels == item.title
                  ? "text-[#7ABF5B] lg:border-b-[6px] sm:border-b-[10px] border-b-[5px] border-[#7ABF5B]"
                  : " text-[#292929]"
              } font-[Rockwell] font-extrabold 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px] text-[17px] px-4 cursor-pointer`}
            >
              {item.title}
            </div>
          </div>
        ))}
      </div>

      {/* Slider */}
      <div className="lg:mx-[40px] sm:mx-[20px] mx-[0px]">
        <div className="grid lg:grid-cols-4 grid-cols-6 gap-4">
          <div className="col-span-1 flex justify-start">
            <img
              src={LeftArrows}
              alt=""
              className="lg:w-[160px] sm:w-[100px] w-[50px] cursor-pointer"
              onClick={handlePrev}
            />
          </div>
          <div className="lg:col-span-2 col-span-4 max-h-[900px] overflow-hidden">
            <img src={activeMachine?.[currentIndex]?.img} alt="" className={`slide-animation ${animationClass}`} />
          </div>
          <div className="col-span-1 flex justify-end">
            <img
              src={RightArrows}
              alt=""
              className="lg:w-[160px] sm:w-[100px] w-[50px] cursor-pointer"
              onClick={handleNext}
            />
          </div>
        </div>

        <div className="lg:mx-[95px] mx-[0px]">
          <div className="font-[Roboto] font-extrabold 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px]">
            {activeMachine?.[currentIndex]?.title}
          </div>
          <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">
            <div className="col-span-2">
              <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px]">
                {activeMachine?.[currentIndex]?.subTitle}
              </div>
            </div>
            <div className="col-span-1">
              <button
                onClick={() => {
                  window.scrollTo(0, 200);
                  navigate(activeMachine?.[currentIndex]?.link);
                }}
                className="text-[#5B792E] font-[Roboto] lg:border-[4px] border-[2px] border-[#5B792E] font-bold lg:px-[51px] sm:px-[41px] px-[31px] lg:py-[17px] sm:py-[15px] py-[10px]  2xl:text-[30px] xl:text-[25px] lg:text-[20px] md:text-[17px] text-[15px]"
              >
                {activeMachine?.[currentIndex]?.btnName}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ModelSlider;
